<template>
  <a
    v-if="'href' in route"
    :href="route.href"
    class="group flex w-full items-center rounded-md p-2 text-sm font-medium text-background-fg/70 hover:bg-background-fg/3 hover:text-background-fg/87"
  >
    <component
      :is="route.icon"
      v-if="route.icon"
      :class="['mr-3 size-6 shrink-0']"
      aria-hidden="true"
    />
    {{ route.label }}
  </a>
  <RouterLink
    v-else
    #default="{
      href: childHref,
      navigate: childNavigate,
      route: { meta: childMeta },
      isExactActive: isChildActive,
    }"
    :to="route"
    custom
  >
    <a
      :href="childHref"
      :class="[
        isChildActive
          ? 'bg-primary/10'
          : 'hover:bg-background-fg/3 hover:text-background-fg/87',
        'group flex w-full items-center rounded-md p-2 text-sm font-medium text-background-fg/70',
      ]"
      @click="childNavigate"
    >
      <component
        :is="childMeta.icon"
        class="mr-3 size-6 shrink-0"
        aria-hidden="true"
        @click="childNavigate"
      />
      {{ childMeta.pageTitle }}
    </a>
  </RouterLink>
</template>

<script setup lang="ts">
import type { Component } from "vue"
import type { RouteLocationAsRelative } from "vue-router"

export type SidebarRoute =
  | RouteLocationAsRelative
  | {
      href: string
      label: string
      icon?: Component
      showAtBottom?: boolean
    }

defineProps<{
  route: SidebarRoute
}>()
</script>
